<ng-container *transloco="let t">
    <div [class]="cssClass">
            @if (overallRank) {
            <div class="rank-icon-item">
            <div class="d-flex align-items-center gap-1">
                <i class="bi bi-trophy-fill rank-icon-item__icon rank-icon-item__icon--overall"></i>
                <span class="fw-600 title">{{overallRank ?? "-"}}</span>
                </div>
        <div class="rank-icon-item__label subtitle">{{t('competitor.table.rank.overall.short')}}</div>
    </div>
            }
            @if (sexRank) {
            <div class="rank-icon-item">
            <div class="d-flex align-items-center gap-1">
                <i class="bi rank-icon-item__icon rank-icon-item__icon--sex"
                   [ngClass]="sex === 2 ? 'bi-gender-female' : 'bi-gender-male'"></i>
                <span class="fw-600 title">{{sexRank ?? "-"}}</span>
        </div>
        <div class="rank-icon-item__label subtitle">
            {{t('competitor.table.rank.sex.short')}}
            @if (sex === 1) {
            ({{t("app.common.gender.short.1")}})
            } @else if (sex === 2) {
            ({{t("app.common.gender.short.2")}})
            }
            </div>
            </div>
            }
            @if (categoryRank) {
            <div class="rank-icon-item">
             <div class="d-flex align-items-center gap-1">
                 <i class="bi bi-people-fill rank-icon-item__icon rank-icon-item__icon--category"></i>
                 <span class="fw-600 title">{{categoryRank ?? "-"}}</span>
        </div>
        <div class="rank-icon-item__label subtitle">{{t('competitor.table.rank.category.short')}}</div>
    </div>
            }
    </div>
</ng-container>